export const LANDING = ["/:token", ""];
export const ADMIN = "/hasiok69";